import React, { useState } from 'react';
import './FAQContent.css';
import FaqData from "../Data/FaqData.json";
import mailData from "../Data/mailData.js";

const Accordion = ({ question, answer }) => {
  const [isActive, setIsActive] = useState(false);

  return (
    <div className="accordion-item">
      <div className={isActive ? "accordion__title_active" : "accordion__title_inactive"} onClick={() => setIsActive(!isActive)}>
        <div>{question}</div>
        <span className="accordion__icon">
          {isActive ? (
            <img
              className="accordion__button__icons"
              src={process.env.PUBLIC_URL + "/images/faq/minus_icon.png"}
              alt="banner"
            />
          ) : (
            <img
              className="accordion__button__icons"
              src={process.env.PUBLIC_URL + "/images/faq/plus_icon.png"}
              alt="banner"
            />
          )}
        </span>
      </div>
      {isActive && <div className={isActive ? "accordion__content_active" : "accordion__content_inactive"} dangerouslySetInnerHTML={{ __html: answer }}></div>}
    </div>
  );
};

function FAQContent() {
  return (
    <>
      <div className="main-banner">
        <img src={process.env.PUBLIC_URL + "/images/faq/FAQ_Banner.png"} alt="Banner" className="banner-img" />
        {/* <div className="banner-content">
                    <h1>QA @ LKM</h1>
                    <p><i>Lorem ipsum is simply dummy text of the printing</i></p>
                </div> */}
      </div>
      {/* <div className='FAQ_container'>
                <h1>QA FAQs</h1>
            </div> */}
      <div className="Faq_main">
        <div className="FAQ__Accordion__container">
          <div>
            <div className="accordion">
              {FaqData.map(({ Questions, Answers }) => (
                <Accordion question={Questions} answer={Answers} />
              ))}
            </div>
          </div>
        </div>
      </div>
      <div className="icons-container">
        <div className="icons-wrap">

          <div className="icons-row row1">
            <div className="icons-box">
              <div className="img-link">
                <img src={process.env.PUBLIC_URL + "/images/Home/contact_icon.png"} alt="Mailicon" className="group-img mailIcon" id="icon-chat" />
                <a className="contact-us" target='_blank' href={`mailto:${mailData.dellearningframework}`}><span className='menu-text'>Write to us</span></a>
                {/* <span className="contact-word">Mail</span> */}
              </div>
            </div>
          </div>

        </div>
      </div>
      <div className='link_container_below'>
        <div className='link_cont_wrap'>
          <div>
            <img src={process.env.PUBLIC_URL + "/images/Home/Acc_GT_Dimensional_RGB.png"} alt="AccentureIcon" className='link_accenture_logo' />
          </div>
          <div className='link_text_cont'>
            <span>For any queries or support, you may reach out to
              <a className="link_anchor" href={`mailto:${mailData.qualityassurance}`} target="_blank"> {mailData.qualityassurance} </a></span>
          </div>
        </div>
      </div>
    </>
  )
}

export default FAQContent;